import "@/App.css";
import { BrowserRouter, Routes, Route, useParams } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { NewCustomerProvider } from "@/context/NewCustomerContext";
import { ChatProvider } from "@/context/ChatContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import AppLayout from "@/components/AppLayout";
import LoginPage from "@/pages/LoginPage";
import ForgotPasswordPage from "@/pages/ForgotPasswordPage";
import ResetPasswordPage from "@/pages/ResetPasswordPage";
import OperatorDashboard from "@/pages/OperatorDashboard";
import UsersPage from "@/pages/UsersPage";
import OfficesPage from "@/pages/OfficesPage";
import CustomersPage from "@/pages/CustomersPage";
import CustomerDetailPage from "@/pages/CustomerDetailPage";
import ScadenzePage from "@/pages/ScadenzePage";
import OpportunitiesPage from "@/pages/OpportunitiesPage";
import QuotesPage from "@/pages/QuotesPage";
import AppointmentsPage from "@/pages/AppointmentsPage";
import ActivitiesPage from "@/pages/ActivitiesPage";
import DashboardDirezionePage from "@/pages/DashboardDirezionePage";
import ProductionPage from "@/pages/ProductionPage";
import TargetsPage from "@/pages/TargetsPage";
import KoPage from "@/pages/KoPage";
import ShiftsPage from "@/pages/ShiftsPage";
import PortfolioPage from "@/pages/PortfolioPage";
import MigrationPage from "@/pages/MigrationPage";
import WhatsAppPage from "@/pages/WhatsAppPage";
import CodaLavoriPage from "@/pages/CodaLavoriPage";
import MonitoraggioPage from "@/pages/MonitoraggioPage";
import GoogleSettingsPage from "@/pages/GoogleSettingsPage";
import ChatPage from "@/pages/ChatPage";

// Rimonta CustomerDetailPage ad ogni cambio di :id.
// Evita che una risposta tardiva del cliente precedente (latenza DB) sovrascriva
// lo stato del nuovo cliente: l'istanza vecchia viene smontata e la nuova carica
// esclusivamente il cliente dell'URL corrente.
function CustomerDetailRoute() {
  const { id } = useParams();
  return <CustomerDetailPage key={id} />;
}

function Protected({ children, adminOnly = false, allow = null, allowEfficienzaGlobal = false }) {
  return (
    <ProtectedRoute adminOnly={adminOnly} allow={allow} allowEfficienzaGlobal={allowEfficienzaGlobal}>
      <NewCustomerProvider>
        <ChatProvider>
          <AppLayout>{children}</AppLayout>
        </ChatProvider>
      </NewCustomerProvider>
    </ProtectedRoute>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/forgot-password" element={<ForgotPasswordPage />} />
            <Route path="/reset-password" element={<ResetPasswordPage />} />

            <Route path="/" element={<Protected><OperatorDashboard /></Protected>} />
            <Route path="/chat" element={<Protected><ChatPage /></Protected>} />
            <Route path="/clienti" element={<Protected><CustomersPage /></Protected>} />
            <Route path="/clienti/:id" element={<Protected><CustomerDetailRoute /></Protected>} />
            <Route path="/whatsapp" element={<Protected><WhatsAppPage /></Protected>} />
            <Route path="/coda-lavori" element={<Protected><CodaLavoriPage /></Protected>} />
            <Route path="/monitoraggio" element={<Protected><MonitoraggioPage /></Protected>} />
            <Route path="/impostazioni/google" element={<Protected adminOnly><GoogleSettingsPage /></Protected>} />
            <Route path="/forniture" element={<Protected><ScadenzePage /></Protected>} />
            <Route path="/efficienza" element={<Protected allow={["admin", "backoffice"]} allowEfficienzaGlobal><OpportunitiesPage /></Protected>} />
            <Route path="/opportunita" element={<Protected allow={["admin", "backoffice"]} allowEfficienzaGlobal><OpportunitiesPage /></Protected>} />
            <Route path="/preventivi" element={<Protected><QuotesPage /></Protected>} />
            <Route path="/appuntamenti" element={<Protected><AppointmentsPage /></Protected>} />
            <Route path="/attivita" element={<Protected><ActivitiesPage /></Protected>} />
            <Route path="/produzione" element={<Protected><ProductionPage /></Protected>} />
            <Route path="/target" element={<Protected><TargetsPage /></Protected>} />
            <Route path="/ko" element={<Protected><KoPage /></Protected>} />
            <Route path="/turni" element={<Protected><ShiftsPage /></Protected>} />
            <Route path="/portafoglio" element={<Protected><PortfolioPage /></Protected>} />

            <Route path="/dashboard-direzione" element={<Protected adminOnly><DashboardDirezionePage /></Protected>} />
            <Route path="/utenti" element={<Protected adminOnly><UsersPage /></Protected>} />
            <Route path="/migrazione" element={<Protected adminOnly><MigrationPage /></Protected>} />
            <Route path="/sedi" element={<Protected adminOnly><OfficesPage /></Protected>} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
